<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        bottom: 66px;
        left: 10px;
        width: 288.08px;
        height: 16.47px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288.08 16.47">
    <defs>
        <style>
            .cls-1 {
                font-size: 12px;
                font-family: AvenirNext-Regular, Avenir Next;
            }
            .cls-2 {
                letter-spacing: -0.01em;
            }
            .cls-3 {
                letter-spacing: 0em;
            }
            .cls-4 {
                letter-spacing: -0.01em;
            }
            .cls-5 {
                letter-spacing: -0.02em;
            }
            .cls-6 {
                letter-spacing: -0.09em;
            }
        </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <text {fill} class="cls-1" transform="translate(0 11.54)">Schedule</text>
            <text {fill} class="cls-1" transform="translate(230.84 10.25)">Teams</text>
        </g>
    </g>
</svg>
